import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';

// import 'materialize-css/dist/css/materialize.css';
import './utils/css/app/noDoubleUnderline.css';
import './utils/css/app/materialize-css/dist/css/materialize.css';
import './utils/css/app/fontOverrides.css';
import './utils/css/app/buttonOverrides.css';
import './utils/css/app/tableOverrides.css';

import App from './components/App';
import reducers from './reducers';

const store = createStore(reducers, {}, applyMiddleware(reduxThunk));

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.querySelector('#root')
);



// WEBPACK FOOTER //
// ./src/index.js